import axios, { AxiosError } from 'axios'

import { getToken } from './cookie'
import { config } from '../config'

/* TODO: При запросах с сервера некста с разных учетных записей
возвращался один и тот же результат */
// import memoize from 'lodash-es/memoize'

// export const getApiClient = memoize(() => {
//   const client = axios.create({
//     baseURL: process.env.NEXT_PUBLIC_API_URL || process.env.API_URL,
//     withCredentials: true
//   })

//   return client
// })

export const getApiClient = (locale: string) => {
  const API_URL = config.isDev
    ? 'https://dev-api.plandi.ru/api'
    : config.isStage
    ? 'https://stage-api.plandi.ru/api'
    : 'https://api.plandi.ru/api'

  const token = getToken()
  const authHeaders = token
    ? {
        Authorization: `Bearer ${token}`,
        locale
      }
    : { locale }

  const client = axios.create({
    // baseURL: process.env.NEXT_PUBLIC_API_URL || process.env.API_URL,
    baseURL: API_URL,
    withCredentials: true,
    headers: {
      ...authHeaders
    }
  })
  client.interceptors.response.use(
    (res) => res,
    (error: AxiosError) => {
      if (error?.response?.status === 500) {
        window.location.replace('/blog/service-unable')
      }
      return Promise.reject(error)
    }
  )
  return client
}
